import { useAuth } from "@/contexts"
import { useViewer } from "@/contexts/ViewerContext"
import { Deal, DealManager } from "@/types"

export interface ClientContext {
  firstName: string
  lastName: string
  email: string
  phoneNumber?: string
  esoId?: number | null
  deals: Deal[]
  dealManager: DealManager
  isViewingAsClient: boolean
  paymentCenterActive?: number
  // DM-enabled escape hatch: 1 → show the manual bank-entry tab.
  manualEntryEnabled?: number
}

export const useClientContext = (): ClientContext | null => {
  const { user } = useAuth()
  const { viewedClient, isViewingAsClient } = useViewer()

  if (isViewingAsClient && viewedClient) {
    return {
      firstName: viewedClient.firstName,
      lastName: viewedClient.lastName,
      email: viewedClient.email,
      phoneNumber: viewedClient.phoneNumber,
      esoId: viewedClient.esoId,
      deals: viewedClient.deals,
      dealManager: viewedClient.dealManager,
      isViewingAsClient: true,
      paymentCenterActive: viewedClient.paymentCenterActive,
      manualEntryEnabled: viewedClient.manualEntryEnabled,
    }
  }

  if (user && user.userType === "client") {
    return {
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      phoneNumber: user.phoneNumber,
      esoId: user.esoId,
      deals: user.deals,
      dealManager: user.dealManager,
      isViewingAsClient: false,
      paymentCenterActive: user.paymentCenterActive,
      manualEntryEnabled: user.manualEntryEnabled,
    }
  }

  return null
}
